"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mombercelli": {
    "f8e5b3f5": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "skipSearch": false
    }],
    "borra": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ede34ebc": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "skipSearch": false
    }],
    "madonna": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9f94688e": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "skipSearch": false
    }],
    "monta": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5d4dc5cb": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "skipSearch": false
    }],
    "nisorella": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "18821677": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "skipSearch": false
    }],
    "pontetto": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1fb8a90b": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "skipSearch": false
    }],
    "sabbione": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f22b9978": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "skipSearch": false
    }],
    "san-sebastiano": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "baa8e665": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "skipSearch": false
    }],
    "vallone": [{
      "hkey": "b41b4ea8",
      "slug": "mombercelli",
      "name": "Mombercelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;